const anima_mixins = {
    data(){
        return {
            id: '59374',
            uid: '8d3cb61cd3446f8f2d193ad6b0069585',
            apiHost: process.env.VUE_APP_API
        }
    },
    props: {
        activePage: Number,
        nextPage: Number,
        jumpView: Number
    },
    watch:{
        nextPage(n,o){ // 监听离开
          if(n - this.activePage > 0 && this.activePage == this.defaultPage){
            //  下滚离开
            this.downLeave()
          }
          if(n - this.activePage < 0 && this.activePage == this.defaultPage){
            // 上滚离开
            this.upLeave()
          }
        },
        activePage(n,o){ // 监听进入
            if( n - o > 0 && this.activePage == this.defaultPage){
                this.downEnter()
            }
            if( n - o < 0 && this.activePage == this.defaultPage){
                this.upEnter()
            }
        },
        jumpView(n){
            if( Math.abs(n - this.activePage) == 1 ){
                return
            }
            if( n > this.activePage ){
                for(let i = this.activePage + 1; i < n; i++){
                    if( n - this.activePage > 0 && this.defaultPage == i ){
                        this.downEnter()
                        this.downLeave()
                    }
                }
            }else{
                for(let i = this.activePage - 1; i > n; i--){
                    if( n - this.activePage < 0 && this.defaultPage == i ){
                        this.upLeave()
                        this.upEnter()
                    }
                }
            }
            // for(let i = small; i < big; i++){
            //     if( this.defaultPage == i ){
            //         if( n - this.activePage > 0 ){
            //             this.downEnter()
            //             this.downLeave()
            //         }
            //         if( n - this.activePage < 0 ){
            //             this.upLeave()
            //             this.upEnter()
            //         }
            //     }
            // }
        }
      },
    methods: {
        initAnime() {
            let el = $('.js-anime')
            if (!el.length) {
                return
            }
            for (let i = 0; i < el.length; i++) {
                let currentEl = el.eq(i)
                // 是否设置过渡时长
                if (currentEl.attr('data-duration')) {
                    currentEl.css('transition', 'all ' + currentEl.attr('data-duration') + 'ms')
                }
                // 如果有延迟
                if (currentEl.attr('data-delay')) {
                    // 添加样式还是移除样式
                    if (currentEl.attr('data-type') == 'remove') {
                        setTimeout(function () {
                            currentEl.removeClass(currentEl.attr('data-anime'))
                        }, currentEl.attr('data-delay'))
                    } else {
                        setTimeout(function () {
                            currentEl.addClass(currentEl.attr('data-anime'))
                        }, currentEl.attr('data-delay'))
                    }
                } else {
                    if (currentEl.attr('data-type') == 'remove') {
                        currentEl.removeClass(currentEl.attr('data-anime'))
                    } else {
                        currentEl.addClass(currentEl.attr('data-anime'))
                    }

                }
            }
        }
    }
}

export {
    anima_mixins
}